import { backendClient } from '../lib/api/backendClient';

interface CatalogComposer {
  id?: string;
  name?: string;
  summary?: string;
  bio?: string;
  description?: string;
  era?: string;
  period?: string;
  style?: string;
  birthYear?: string | number;
  birth_year?: string | number;
  birth?: string | number;
  deathYear?: string | number;
  death_year?: string | number;
  death?: string | number;
  spotifyArtistId?: string;
  spotify_artist_id?: string;
  [key: string]: unknown;
}

export const composerService = {
  async fetchById(composerId: string): Promise<CatalogComposer | null> {
    if (!composerId) return null;
    try {
      const { data } = await backendClient.get<{ composer?: CatalogComposer }>(
        `/catalog/composers/${encodeURIComponent(composerId)}`
      );
      return data?.composer ?? null;
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('[composerService] fetchById failed, returning null', error);
      }
      return null;
    }
  },

  async fetchBySpotifyId(spotifyArtistId: string): Promise<CatalogComposer | null> {
    if (!spotifyArtistId) return null;
    try {
      const { data } = await backendClient.get<{ composer?: CatalogComposer }>(
        `/catalog/composers/by-spotify/${encodeURIComponent(spotifyArtistId)}`
      );
      return data?.composer ?? null;
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('[composerService] fetchBySpotifyId failed, returning null', error);
      }
      return null;
    }
  },
};

export type { CatalogComposer };
